import React, {useEffect,useState} from 'react';
import {getMaterialExport} from '../../lib/brandStudioApi';

// A historical binary is displayed/downloaded, never independently rendered.
export default function MaterialExportLinkV1({projectId,mediaId}) {
  const [url,setUrl]=useState(null),[error,setError]=useState(false);
  useEffect(()=>{
    let live=true,created;setUrl(null);setError(false);
    getMaterialExport(projectId,mediaId).then(blob=>{if(live){created=URL.createObjectURL(blob);setUrl(created);}}).catch(()=>{if(live)setError(true);});
    return()=>{live=false;if(created)URL.revokeObjectURL(created);};
  },[projectId,mediaId]);
  return url?<a href={url} download="thank-you-previous.png" className="text-sm underline" data-testid="ap2-previous-download">Скачать прежний PNG</a>:error?<p className="text-sm">Не удалось открыть прежний PNG.</p>:null;
}
